import React from 'react';
import { Box } from '@mui/material';

import { Field, SectionTitle } from '@components';
import {
  businessDepositsAveragePaymentsOptions,
  businessDepositsAgeOptions,
  businessDepositsTurnoverOptions,
  businessDepositsNumberOfVehiclesOptions,
  businessDepositsUnpaidAmountOptions,
  businessDepositsUnpaidAgingDaysOptions,
  businessStandingOrderAveragePaymentsOptions,
  businessStandingOrderAgeOptions,
  businessStandingOrderTurnoverOptions,
  businessStandingOrderNumberOfVehiclesOptions,
  businessStandingOrderUnpaidAmountOptions,
  businessStandingOrderUnpaidAgingDaysOptions,
  businessStandingOrderSuccessRateFixedAssetsOptions,
} from '@constants';

import styles from './creditScoreForm.style';

export const Business = ({ loading, methods }) => {
  const _getTotal = (type) => {
    return methods.getValues(`b2b.${type}.total`) || '-';
  };

  const _isRequired = (field) => {
    const state = methods.getFieldState(field);
    return state.invalid || state.isDirty;
  };

  return (
    <Box sx={{ ...styles.section }}>
      <SectionTitle styles={{ ...styles.title }}>B2B</SectionTitle>

      <Box sx={{ ...styles.subsection }}>
        <div>
          <SectionTitle styles={{ ...styles.subtitle }}>
            {`Deposit (Score: ${_getTotal('deposit')})`}
          </SectionTitle>

          <Box sx={{ ...styles.row }}>
            <Field
              label="Μ.Ο. ΠΛΗΡΩΜΩΝ"
              name="b2b.deposit.averagePaymentDays"
              control={methods.control}
              type="dropdown"
              options={businessDepositsAveragePaymentsOptions}
              disabled={loading}
              isRequired={_isRequired('b2b.deposit.averagePaymentDays')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="ΗΛΙΚΙΑ"
              name="b2b.deposit.age"
              control={methods.control}
              type="dropdown"
              options={businessDepositsAgeOptions}
              disabled={loading}
              isRequired={_isRequired('b2b.deposit.age')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="ΤΖΙΡΟΣ"
              name="b2b.deposit.turnover"
              control={methods.control}
              type="dropdown"
              options={businessDepositsTurnoverOptions}
              disabled={loading}
              isRequired={_isRequired('b2b.deposit.turnover')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="ΟΧΗΜΑΤΑ"
              name="b2b.deposit.vehicles"
              control={methods.control}
              type="dropdown"
              options={businessDepositsNumberOfVehiclesOptions}
              disabled={loading}
              isRequired={_isRequired('b2b.deposit.vehicles')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="AΝΕΞΟΦΛΗΤO ΠΟΣΟ"
              name="b2b.deposit.unpaidAmount"
              control={methods.control}
              type="dropdown"
              options={businessDepositsUnpaidAmountOptions}
              disabled={loading}
              isRequired={_isRequired('b2b.deposit.unpaidAmount')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="AΝΕΞΟΦΛΗΤO ΠΟΣΟ AGING"
              name="b2b.deposit.unpaidAgingDays"
              control={methods.control}
              type="dropdown"
              options={businessDepositsUnpaidAgingDaysOptions}
              disabled={loading}
              isRequired={_isRequired('b2b.deposit.unpaidAgingDays')}
            />
          </Box>
        </div>

        <div>
          <SectionTitle styles={{ ...styles.subtitle }}>
            {`Standing Order (Score: ${_getTotal('standingOrder')})`}
          </SectionTitle>

          <Box sx={{ ...styles.row }}>
            <Field
              label="Μ.Ξ. ΠΛΗΡΩΜΩΝ"
              name="b2b.standingOrder.averagePaymentDays"
              control={methods.control}
              type="dropdown"
              options={businessStandingOrderAveragePaymentsOptions}
              disabled={loading}
              isRequired={_isRequired('b2b.standingOrder.averagePaymentDays')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="ΗΛΙΚΙΑ"
              name="b2b.standingOrder.age"
              control={methods.control}
              type="dropdown"
              options={businessStandingOrderAgeOptions}
              disabled={loading}
              isRequired={_isRequired('b2b.standingOrder.age')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="ΤΖΙΡΟΣ"
              name="b2b.standingOrder.turnover"
              control={methods.control}
              type="dropdown"
              options={businessStandingOrderTurnoverOptions}
              disabled={loading}
              isRequired={_isRequired('b2b.standingOrder.turnover')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="ΟΧΗΜΑΤΑ"
              name="b2b.standingOrder.vehicles"
              control={methods.control}
              type="dropdown"
              options={businessStandingOrderNumberOfVehiclesOptions}
              disabled={loading}
              isRequired={_isRequired('b2b.standingOrder.vehicles')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="AΝΕΞΟΦΛΗΤO ΠΟΣΟ"
              name="b2b.standingOrder.unpaidAmount"
              control={methods.control}
              type="dropdown"
              options={businessStandingOrderUnpaidAmountOptions}
              disabled={loading}
              isRequired={_isRequired('b2b.standingOrder.unpaidAmount')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="AΝΕΞΟΦΛΗΤO ΠΟΣΟ AGING"
              name="b2b.standingOrder.unpaidAgingDays"
              control={methods.control}
              type="dropdown"
              options={businessStandingOrderUnpaidAgingDaysOptions}
              disabled={loading}
              isRequired={_isRequired('b2b.standingOrder.unpaidAgingDays')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="ΠΟΣΟΣΤΟ ΕΠΙΤΥΧΙΑΣ ΠΑΓΙΩΝ"
              name="b2b.standingOrder.successRateStandingOrders"
              control={methods.control}
              type="dropdown"
              options={businessStandingOrderSuccessRateFixedAssetsOptions}
              disabled={loading}
              isRequired={_isRequired(
                'b2b.standingOrder.successRateStandingOrders'
              )}
            />
          </Box>
        </div>
      </Box>
    </Box>
  );
};

export default Business;
